// ============================================================================
// HoneypotField — invisible form field for bot detection.
//
// Bots auto-fill every form field they see. Humans never see this one.
// If the field has any value when the form is submitted, the backend
// silently rejects the submission and returns a fake 200 OK so the bot
// thinks it succeeded (and doesn't learn how to bypass).
//
// Usage in any public form:
//   const [honeypot, setHoneypot] = useState('');
//   ...
//   <HoneypotField value={honeypot} onChange={setHoneypot} />
//   ...
//   body: JSON.stringify({ ...formData, website: honeypot })
//
// The field name `website` is intentionally generic — bots target it.
// ============================================================================
import React from 'react';

const HONEYPOT_STYLES = {
  // Off-screen, invisible to humans
  position: 'absolute',
  left: '-9999px',
  top: '-9999px',
  width: '1px',
  height: '1px',
  opacity: 0,
  pointerEvents: 'none',
  // Belt + suspenders for screen-reader-friendly browsers
  overflow: 'hidden',
};

const HoneypotField = ({ value, onChange, name = 'website' }) => {
  return (
    <div style={HONEYPOT_STYLES} aria-hidden="true">
      <label htmlFor={`hp-${name}`}>
        Leave this field empty
      </label>
      <input
        id={`hp-${name}`}
        type="text"
        name={name}
        value={value || ''}
        onChange={(e) => onChange && onChange(e.target.value)}
        autoComplete="off"
        tabIndex={-1}
        aria-hidden="true"
      />
    </div>
  );
};

export default HoneypotField;
